import React from 'react';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import Refunding from '@app/model/market_state/Refunding';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';


type DashboardSelectIsRefundableFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectIsRefundableFilter = React.memo(
	function DashboardSelectIsRefundableFilter({ filter, onFilter }: DashboardSelectIsRefundableFilterProps) {
		const {isDashboardFilterEnabled} = useMarketStateFilterInputTools()
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.FLEX);

		const menuItems = [
			{ name: 'Lowest', description: 'Lowest available rate', value: Refunding.NONE },
			{ name: 'Lowest flex', description: 'Lowest available flexible rate', value: Refunding.FULL },
		];

		const onSelect = (refunding: Refunding) => {
			onFilter({ ...filter, refunding: refunding });
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.refunding}
														 onSelect={onSelect}
														 disabled={!providerSupportsFilter}
														 menuDescription="Select the rate category you wish to compare your competitors with." />;

	},
);

export default DashboardSelectIsRefundableFilter;